import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { CardWithTitleChip } from "components/CardWithTitleChip";
import { SanitizedHtml } from "components/SanitizedHtml";

import { ParagraphLarge } from "styles/elements/Texts";
import { CssFlex } from "styles/helpers/layout";

export const StyledModuleCard = styled(CardWithTitleChip)<ThemeProps>`
  width: 21rem;
  min-height: 21rem;
  border-radius: 16px;
`;

export const StyledSubtitle = styled.span<ThemeProps>`
  font-size: ${(props: ThemeProps) => props.theme.font.size._18};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.bold};
`;

export const StyledLastPracticedDate = styled(CssFlex)`
  font-size: ${(props: ThemeProps) => props.theme.font.size._12};
`;

export const StyledLastPracticedTopicTitle = styled(SanitizedHtml)`
  font-size: ${(props: ThemeProps) => props.theme.font.size._18};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.bold};
`;

export const StyledProgressBarLabel = styled(ParagraphLarge)`
  padding-top: 8px;
  border-top: 1px solid ${(props: ThemeProps) => props.theme.palette.neutral._800};
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};
`;
